"use client";
import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Paper,
  Grid,
  FormControl,
  Link,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PaymentSucessfullGif from "../Assets/Img/payment succesfull gif.gif";
import { Modal } from "@mui/material";
import "../Brand/../Assets/css/index.css";

export default function MembershipUpgrade() {
  const [membershipType, setMembershipType] = useState("annually");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const handleMembershipChange = (event) => {
    setMembershipType(event.target.value);
  };

  const handleUpgradeClick = () => {
    // You can add payment processing logic here if needed
    setOpenSuccessModal(true);
  };

  const handleCloseModal = () => {
    setOpenSuccessModal(false);
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        p={2}
        flexDirection="column"
      >
        {/* Back Button */}
        {/* Container to align Back button with Card's left edge */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 1200,
            alignSelf: "center", // centers the card horizontally
          }}
        >
          <button
            className="button-back mb-2"
            onClick={() => window.history.back()}
          >
            &lt; Back
          </button>
        </Box>

        {/* Card Centered */}
        <Card
          sx={{
            width: "100%",
            maxWidth: 1200,
            borderRadius: 3,
            boxShadow: 0,
            border: "1px solid rgba(221, 221, 221, 1)", // Added border here
            p: 2,
          }}
        >
          <CardContent>
            <Typography
              className="upgrade-text"
              variant="h5"
              fontWeight={600}
              gutterBottom
            >
              Upgrade to a Basic Membership
            </Typography>
            <Typography
              className="upgrade-text mb-4"
              variant="body2"
              color="text.secondary"
              gutterBottom
            >
              Get all access and an extra 20% off when you subscribe annually
            </Typography>

            <Grid container spacing={4} className="mb-5">
              <Grid item xs={12} md={6}>
                <Box mb={2}>
                  <Typography variant="subtitle2">Card Number</Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter Your Card Number Here"
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid rgba(155, 155, 155, 1)",
                        borderRadius: "4px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  />
                </Box>

                <Box mb={2}>
                  <Typography variant="subtitle2">Name on Card</Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter Your Name On Card"
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid rgba(155, 155, 155, 1)",
                        borderRadius: "4px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  />
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Typography variant="subtitle2">Expiry Month</Typography>
                    <TextField
                      fullWidth
                      placeholder="Month"
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          border: "1px solid rgba(155, 155, 155, 1)",
                          borderRadius: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="subtitle2">Expiry Year</Typography>
                    <TextField
                      fullWidth
                      placeholder="Year"
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          border: "1px solid rgba(155, 155, 155, 1)",
                          borderRadius: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <Typography variant="subtitle2">CVV</Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter Card CVV"
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          border: "1px solid rgba(155, 155, 155, 1)",
                          borderRadius: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">Promo Code</Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter Promo Code"
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          border: "1px solid rgba(155, 155, 155, 1)",
                          borderRadius: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ maxWidth: "350px", width: "350px" }}>
                  <Typography variant="subtitle2" mb={1}>
                    Membership Type
                  </Typography>
                  <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                      value={membershipType}
                      onChange={handleMembershipChange}
                    >
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 2,
                          border: "1px solid rgba(221, 221, 221, 1)",
                        }}
                      >
                        <FormControlLabel
                          value="monthly"
                          control={<Radio />}
                          label={
                            <Box>
                              <Typography variant="body1" fontWeight={500}>
                                Pay Monthly
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                $39 / Month Per Member
                              </Typography>
                            </Box>
                          }
                        />
                      </Paper>

                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          position: "relative",
                          borderColor:
                            membershipType === "annually"
                              ? "primary.main"
                              : "divider",
                          border: "1px solid rgba(221, 221, 221, 1)",
                        }}
                      >
                        <FormControlLabel
                          value="annually"
                          control={<Radio />}
                          label={
                            <Box>
                              <Typography variant="body1" fontWeight={500}>
                                Pay Annually
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                $35 / Month Per Member
                              </Typography>
                            </Box>
                          }
                        />
                        {membershipType === "annually" && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              backgroundColor: "#",
                              color: "black",
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 1,
                              fontSize: "0.75rem",
                            }}
                          >
                            Save 20%
                          </Box>
                        )}
                      </Paper>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              gap={3}
            >
              <Box>
                <Typography variant="h6" fontWeight={600}>
                  $35.00 / Month
                </Typography>
                <Link href="#" underline="hover" color="text.secondary">
                  Details
                </Link>
              </Box>
              <button
                className="upgrade-plan"
                sx={{
                  borderRadius: 2,
                  backgroundColor: "rgba(107, 142, 118, 1)",
                  color: "white",
                }}
                onClick={handleUpgradeClick}
              >
                Upgrade Plan
              </button>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Modal open={openSuccessModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 4,
            pt: 2,
            textAlign: "center",
          }}
        >
          {/* Close button */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            disableRipple
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              padding: "4px",
              color: (theme) => theme.palette.grey[500],
              border: "none", // Optional but harmless
              "&:hover": {
                backgroundColor: "transparent", // Optional: prevents hover background
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Content */}
          <img
            src={PaymentSucessfullGif} // Replace with success gif
            alt="Success"
            style={{ width: "100px", height: "100px" }}
          />
          <Typography fontWeight="600">
            Your Payment is Successfully Completed!
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
